if (window.pageYOffset > 250) {
    if (document.getElementById("header")) {
        document.getElementById("header").classList.add("header__sticky")
    }
} else {
    if (document.getElementById("header")) {
        document.getElementById("header").classList.remove("header__sticky")
    }
}

window.addEventListener("scroll", event => {
    if (window.pageYOffset > 250) {
        if (document.getElementById("header")) {
            document.getElementById("header").classList.add("header__sticky")
        }
    } else {
        if (document.getElementById("header")) {
            document.getElementById("header").classList.remove("header__sticky")
        }
    }
});

function goTopTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

function openPhoneMenu() {
    if (document.getElementById("phoneMenu")) {
        document.getElementById("phoneMenu").classList.add("header__phone__container__active")
    }
    if (document.getElementById("closePhone")) {
        document.getElementById("closePhone").classList.add("header__menu__phone__icon__close__on")
    }
    if (document.getElementById("openPhone")) {
        document.getElementById("openPhone").classList.add("header__menu__phone__icon__close__off")
    }
}

function closePhoneMenu() {
    if (document.getElementById("phoneMenu")) {
        document.getElementById("phoneMenu").classList.remove("header__phone__container__active")
    }
    if (document.getElementById("closePhone")) {
        document.getElementById("closePhone").classList.remove("header__menu__phone__icon__close__on")
    }
    if (document.getElementById("openPhone")) {
        document.getElementById("openPhone").classList.remove("header__menu__phone__icon__close__off")
    }
}

function showVinkort() {
    if (document.getElementById("vinkort")) {
        document.getElementById("vinkort").classList.toggle("phone__dropdown__display")
    }
}

function showArrangementer() {
    if (document.getElementById("arrangementer")) {
        document.getElementById("arrangementer").classList.toggle("display")
    }
}

function toggleFilters(id) {
    if (document.getElementById("filters-" + id)) {
        document.getElementById("filters-" + id).classList.toggle("display");
    }
}